import React from 'react';
import { IntlProvider } from 'react-intl';
import { userProfileRequest, logoutRequest } from 'redux/User/actions';
import { connect } from 'react-redux';
import sessionTimeoutManager from 'utils/sessionTimeout';
import SessionTimeoutWarning from 'components/SessionTimeoutWarning';
import enMessages from '../../translations/en.json';

import HeaderContainer from '../Header';
import Body from '../Body';
import { flattenMessages } from '../../services/translations/intl';

const locales = {
  en: flattenMessages(enMessages),
};

const mapDispatchToProps = (dispatch) => ({
  fetchUserProfile: () => dispatch(userProfileRequest()),
  logoutUser: () => dispatch(logoutRequest()),
});

class Root extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showTimeoutWarning: false,
      remainingMinutes: 5,
    };
    this.initializeSessionTimeout();
  }

  componentWillUnmount() {
    // Clean up session timeout monitoring
    sessionTimeoutManager.stopMonitoring();
  }

  // Initialize session timeout monitoring for CWE-613 compliance
  initializeSessionTimeout = () => {
    const onSessionTimeout = () => {
      const { logoutUser } = this.props;
      logoutUser();

      // Redirect to login
      window.location.href = '/login';
    };

    const onSessionWarning = (remainingMinutes) => {
      this.setState({
        showTimeoutWarning: true,
        remainingMinutes,
      });
    };

    // Start session timeout monitoring
    sessionTimeoutManager.startMonitoring(onSessionTimeout, onSessionWarning);
  };

  // Handle extending the session
  handleExtendSession = () => {
    this.setState({ showTimeoutWarning: false });
    sessionTimeoutManager.extendSession();
  };

  // Handle immediate logout
  handleImmediateLogout = () => {
    const { logoutUser } = this.props;

    this.setState({ showTimeoutWarning: false });

    // Clear authentication cookies
    document.cookie = 'user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'role=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

    // Stop session monitoring
    sessionTimeoutManager.stopMonitoring();

    // Logout user
    logoutUser();

    // Redirect to login
    window.location.href = '/login';
  };

  render() {
    const locale = 'en';
    const { children } = this.props;
    const { showTimeoutWarning, remainingMinutes } = this.state;

    return (
      <IntlProvider locale={locale} messages={locales[locale]}>
        <div className="mdk-header-layout js-mdk-header-layout" data-domfactory-upgraded="mdk-header-layout" data-select2-id="14">
          <HeaderContainer />
          <Body>{children}</Body>

          {/* Session Timeout Warning Dialog (CWE-613 compliance) */}
          <SessionTimeoutWarning
            open={showTimeoutWarning}
            remainingMinutes={remainingMinutes}
            onExtendSession={this.handleExtendSession}
            onLogout={this.handleImmediateLogout}
          />
        </div>
      </IntlProvider>
    );
  }
}

export default connect(null, mapDispatchToProps)(Root);
